<template>
  <div class="col-sm-6 col-md-4">
    <div class="card">
      <h5 class="card-header">{{ stock.name }} - {{ stock.quantity }}</h5>
      <div class="card-body">
        <p>Price: ${{ stock.price }}</p>
        <input
          type="number"
          class="form-control"
          placeholder="Quantity"
          v-model="quantity"
          :class="{dangerous: insufficientQuantity}"
        >
        <button
          class="btn btn-primary mt-2"
          @click="sellStock"
          :disabled="quantity <= 0 || insufficientQuantity"
        >{{ insufficientQuantity ? 'Not enough stocks' : 'Sell' }}</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .dangerous {
    border: 1px solid red;
  }
  .sodanger {
    color: red;
  }
</style>

<script>
  import {mapActions} from 'vuex'; // Lecture 292

  export default {
    props: ['stock'],
    data () {
      return {
        quantity: 0,
      }
    },
    computed: { // Lecture 296
      insufficientQuantity() {
        return this.quantity > this.stock.quantity;
      }
    },
    methods: {
      ...mapActions({
        placeSellOrder: 'sellStock',
      }),
      sellStock() { // Lecture
        const order = {
          stockId: this.stock.id,
          stockPrice: this.stock.price,
          quantity: this.quantity,
        };
        console.log(order);
        // this.$store.dispatch('sellStock', order);
        this.placeSellOrder(order);
        this.quantity = 0;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/portfolio/Stock.vue